module.exports = __webpack_public_path__ + "static/media/33-miami.15ec2ddd.jpg";